import React from 'react'

import Svg from './svg'


export default function CollapseIcon({width, height, color, ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="collapse" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <polygon id="Path" fill={color} points="80.2524156 28 86 34.8837329 50 78 14 34.8837329 19.7475844 28 50 62.8862305"></polygon>
        </g>
    </Svg>
}
